import React, { useEffect, useState } from "react";
import "./Contact.css";
import "../../global/main.css";
import { Element } from "react-scroll";
import "aos/dist/aos.css";
import Aos from "aos";
import HomeBody from "../../image/HomeBody-01.png";

const Contact = (props) => {
  const isMobile = props.isMobile || false;
  const [activeCard, setActiveCard] = useState(null);

  useEffect(() => {
    Aos.init({
      duration: 500,
      once: true,
      disable: isMobile ? false : "mobile",
    });
  }, [isMobile]);

  const contactInfo = [
    {
      id: 1,
      title: "خدمة العملاء",
      value: "+963 950 037 317",
      whatsApp: "963950037317",
      type: "phone",
      icon: "bx bxs-phone-call",
      color: "#4CAF50",
      description: "متاحون لخدمتكم على مدار الساعة",
    },
    {
      id: 2,
      title: "قسم المبيعات",
      value: "+963 950 037 310",
      whatsApp: "963950037310",
      type: "phone",
      icon: "bx bxs-user-badge",
      color: "#2196F3",
      description: "لاستشاراتكم ومشاريعكم الخاصة",
    },
    {
      id: 3,
      title: "العنوان",
      value: "سوريا , دشمق",
      type: "address",
      icon: "bx bxs-map",
      color: "#FF9800",
      description:
        "شارع الأرجنتين , مقابل فندق الفورسيزن , بجوار القصر الفرنسي",
    },
    {
      id: 4,
      title: "البريد الإلكتروني",
      value: "info@alyousser.com",
      type: "email",
      icon: "bx bxl-gmail",
      color: "#E91E63",
      description: "راسلونا على بريدنا الإلكتروني",
    },
  ];

  const socialLinks = [
    {
      name: "فيسبوك",
      icon: "bx bxl-facebook",
      url: "#",
      color: "#1877F2",
    },
    {
      name: "تويتر",
      icon: "bx bxl-twitter",
      url: "#",
      color: "#1DA1F2",
    },
    {
      name: "لينكد إن",
      icon: "bx bxl-linkedin",
      url: "#",
      color: "#0077B5",
    },
    {
      name: "إنستغرام",
      icon: "bx bxl-instagram",
      url: "#",
      color: "#E4405F",
    },
  ];

  return (
    <Element name="Contact">
      <section className="Contact">
        {/* Background Elements */}
        <div className="contact-bg-elements">
          <div className="bg-circle circle-1"></div>
          <div className="bg-circle circle-2"></div>
          <div className="bg-circle circle-3"></div>
          <div className="bg-shape shape-1"></div>
          <div className="bg-shape shape-2"></div>
        </div>

        <div className="contact-container-wrapper">
          {/* العنوان الرئيسي المعدل */}
          <div
            className="contact-main-header"
            data-aos="fade-down"
            data-aos-duration="1000"
          >
            {/* <h1 className="main-title">
              دعونا نعمل <span>معاً</span>
            </h1> */}
            {/* <p className="main-subtitle"> */}
            <h1 className="main-title">
              نحن هنا لمساعدتك في تحقيق <span>رؤيتك العمرانية </span>
            </h1>
          </div>

          <div className="Contact-container">
            {/* Left Section - Contact Info */}
            <div className="Contact-left">
              {/* Contact Info Cards */}
              <div className="contact-info-grid">
                {contactInfo.map((item, index) => (
                  <div
                    key={item.id}
                    className={`contact-card ${
                      activeCard === item.id ? "active" : ""
                    }`}
                    data-aos="fade-up"
                    data-aos-duration="1500"
                    data-aos-delay={index * 100}
                    // onMouseEnter={() => setActiveCard(item.id)}
                    // onMouseLeave={() => setActiveCard(null)}
                  >
                    <div className="card-icon">
                      <i
                        style={{ backgroundColor: item.color }}
                        className={item.icon}
                      ></i>
                      <h3>{item.title}</h3>
                    </div>
                    <div className="card-content">
                      {item.type === "phone" || item.type === "email" ? (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={
                            item.type === "phone"
                              ? // ? `tel:${item.whatsApp}`
                                `https://wa.me/${item.whatsApp}`
                              : `mailto:${item.value}`
                          }
                          className="contact-link"
                        >
                          {item.value}
                        </a>
                      ) : (
                        <p className="contact-value">{item.value}</p>
                      )}
                      <p className="card-description">{item.description}</p>
                    </div>
                    <div
                      className="card-hover-effect"
                      style={{ backgroundColor: item.color }}
                    ></div>
                  </div>
                ))}
              </div>

              {/* Social Media Links */}
              <div
                className="social-section"
                data-aos="fade-up"
                data-aos-duration="1800"
              >
                <h3 className="social-title">تابعونا على وسائل التواصل</h3>
                <div className="social-links">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.url}
                      className="social-link"
                      style={{ "--social-color": social.color }}
                      data-aos="zoom-in"
                      data-aos-delay={index * 150}
                    >
                      <i className={social.icon}></i>
                      <span>{social.name}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Section - Visual Element */}
            <div className="Contact-right">
              <div
                className="visual-container"
                data-aos="fade-left"
                data-aos-duration="2000"
              >
                <div className="floating-elements">
                  <div className="floating-element element-1">
                    <i className="bx bxs-phone"></i>
                  </div>
                  <div className="floating-element element-2">
                    <i className="bx bxs-envelope"></i>
                  </div>
                  <div className="floating-element element-3">
                    <i className="bx bxs-map"></i>
                  </div>
                  <div className="floating-element element-4">
                    <i className="bx bxs-chat"></i>
                  </div>
                </div>

                <div className="main-visual">
                  <div className="visual-circle">
                    <div className="pulse-effect"></div>
                    <div className="visual-icon">
                      <i className="bx bxs-conversation"></i>
                    </div>
                  </div>
                  <div className="visual-text">
                    {/* <h3>نحن نستمع إليك</h3> */}
                    <p>لا تتردد في التواصل معنا</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom CTA Section */}
          <div
            className="contact-cta"
            data-aos="fade-up"
            data-aos-duration="1500"
          >
            <div className="cta-content">
              <h3>مستعدون لبدء مشروعك؟</h3>
              <p>اتصل بنا الآن وابدأ رحلة النجاح معاً</p>
              <div className="cta-buttons">
                <a href="tel:+963950037317" className="cta-btn primary">
                  <i className="bx bxs-phone"></i>
                  اتصل الآن
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://wa.me/963950037317"
                  className="cta-btn secondary"
                >
                  <i className="bx bxl-whatsapp"></i>
                  واتساب
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Contact;
